// The hero's phone mock reads better when it's showing the visitor's own week
// rather than whenever the site was last built. The markup ships with
// build-time values (see plugins/builders/hero_helpers.rb); this swaps in the
// local ones and keeps the clock ticking.

const clocks = document.querySelectorAll("[data-hero-clock]")
const weeks = document.querySelectorAll("[data-hero-week]")

const clockFormat = new Intl.DateTimeFormat([], { hour: "numeric", minute: "2-digit" })
const weekFormat = new Intl.DateTimeFormat([], { month: "short", day: "numeric", year: "numeric" })

// Honors the visitor's 12/24-hour preference but drops AM/PM, the way the iOS
// status bar does, so rebuild the string from the parts.
function clockText(now) {
  const parts = clockFormat.formatToParts(now)
  const value = (type) => parts.find((part) => part.type === type)?.value ?? ""
  return `${value("hour")}:${value("minute")}`
}

// Monday through Sunday, the week Zone2 totals against.
function weekText(now) {
  const monday = new Date(now)
  monday.setHours(0, 0, 0, 0)
  monday.setDate(monday.getDate() - ((monday.getDay() + 6) % 7))

  const sunday = new Date(monday)
  sunday.setDate(sunday.getDate() + 6)

  return weekFormat.formatRange(monday, sunday)
}

function render() {
  const now = new Date()
  clocks.forEach((el) => (el.textContent = clockText(now)))
  weeks.forEach((el) => (el.textContent = weekText(now)))

  // Line the next update up with the minute boundary, which also rolls the
  // week over at midnight on a page left open.
  setTimeout(render, 60_000 - (now.getSeconds() * 1000 + now.getMilliseconds()))
}

if (clocks.length || weeks.length) render()
